// Classname
import classNames from 'classnames'

// Mantine
import { Tooltip } from '@mantine/core'
import { useClipboard } from '@mantine/hooks'

export default function SKU({ component, size = 'md' }) {
    const category_prefix =
        component?.component_category?.sku_prefix ??
        component?.component_categories?.sku_prefix ??
        component?.category?.sku_prefix ??
        component?.sku_prefix

    const componentId = component?.id ?? component?.component_id

    const SKU = category_prefix + componentId.toString().padStart(4, '0')

    // Classname

    const className = classNames(
        'bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-full font-mono cursor-pointer w-fit',
        {
            'text-xs px-1.5 py-0.5': size === 'xs',
            'text-sm px-2 py-0.5': size === 'sm',
            'px-3 py-1': size === 'md',
        }
    )

    /*
    const className = classNames(
        'text-gray-800 hover:text-gray-600 select-none rounded-full font-mono cursor-pointer',
        {
            'text-sm': size === 'sm',
        }
    )
        */

    // Clipboard
    const clipboard = useClipboard({ timeout: 500 })
    const tooltilLabel = clipboard.copied ? 'Copié !' : 'Copier le SKU ' + SKU

    const copyInClipboard = (e) => {
        e.stopPropagation()
        e.preventDefault()
        clipboard.copy(SKU)
    }

    if (!category_prefix) return null

    return (
        <Tooltip label={tooltilLabel}>
            <div className={className} onClick={copyInClipboard}>
                {SKU}
            </div>
        </Tooltip>
    )
}
